// Department-specific Daily Tracker Work Options
// Department User / Manager sees options tailored to their department.
// If an employee has no department, all options remain accessible as a fallback.

export const DEPARTMENT_TRACKER_OPTIONS = {
  "Management": {
    linkedWork: [], // Nil
    directWork: [
      "Strategic Performance Review Meeting",
      "Tactial Performance Review Meeting",
      "Operational Performance Review Meeting",
      "Training / Facilitation",
      "Coaching / School Support",
      "Sales / Business Development",
      "Marketing / Brand Development",
      "Strategic Partnerships / Relationships",
      "School / Client Visit",
      "Administrative Work",
      "Other",
    ],
  },
  "Marketing & Communications": {
    linkedWork: [
      "Creative Asset",
    ],
    directWork: [
      "Marketing Planning",
      "Campaign Planning",
      "Content Planning",
      "Content Development",
      "Social Media Planning",
      "Social Media Publishing",
      "Brand & Communications",
      "Event Planning / Outreach",
      "Marketing Meeting",
      "Research",
      "Photography",
      "Videography",
      "Video Editing",
      "Photo Editing",
      "Event / Shoot Support",
      "Business Travel – Marketing",
      "Administrative Work",
      "Other",
    ],
  },
  "Sales & Business Development": {
    linkedWork: [
      "Sales Pipeline", // future connection only
    ],
    directWork: [
      "Calling",
      "Emailing",
      "Follow-up",
      "Sales Presentation",
      "Proposal Preparation",
      "Negotiation Meeting",
      "Sales Planning",
      "Sales Reporting",
      "Business Travel – Sales",
      "Administrative Work",
      "Other",
    ],
  },
  "Operations & Customer Success": {
    linkedWork: [
      "School / Client",
    ],
    directWork: [
      "Report Writing",
      "Team Meeting",
      "Learning & Development",
      "Preparing for Coaching / School Visit",
      "Developing Content",
      "School Follow-up",
      "Progress Tracking / Review",
      "School / Client Meeting",
      "Business Travel – Customer Success",
      "Administrative Support",
      "Other",
    ],
  },
  "People & Culture": {
    linkedWork: [],
    directWork: [
      "Recruitment",
      "Candidate Screening",
      "Interview",
      "Employee Onboarding",
      "Employee Support",
      "HR Documentation",
      "Performance & Appraisal",
      "Learning & Development",
      "Employee Engagement",
      "Policy / Process Development",
      "Team Meeting",
      "Reporting",
      "Administrative Work",
      "Other",
    ],
  },
  "Finance & Compliance": {
    linkedWork: [],
    directWork: [
      "Accounts",
      "Billing",
      "Receivables",
      "Payments",
      "Expense Processing",
      "Travel Reimbursement",
      "Payroll",
      "Compliance",
      "Financial Reporting",
      "Reconciliation",
      "Finance Meeting",
      "Administrative Work",
      "Other",
    ],
  },
  "Innovation & Product Development": {
    linkedWork: [],
    directWork: [
      "Product Development",
      "Curriculum Development",
      "Content Development",
      "Research",
      "Innovation",
      "Quality & Improvement",
      "Product Review",
      "Testing",
      "Team Meeting",
      "Documentation",
      "Reporting",
      "Administrative Work",
      "Other",
    ],
  },
  "Administration & Logistics": {
    linkedWork: [],
    directWork: [
      "Administration",
      "Procurement",
      "Asset Management",
      "Logistics",
      "Event Support",
      "Travel Coordination",
      "Vendor Coordination",
      "Documentation",
      "Office Support",
      "Team Meeting",
      "Reporting",
      "Administrative Work",
      "Other",
    ],
  },
};

// Fallback generic options when user has no department assigned yet
export const DEFAULT_DIRECT_TASKS = [
  "Meeting",
  "Call",
  "Planning",
  "Review",
  "Research",
  "Documentation",
  "Training",
  "Administrative Work",
  "Travel",
  "Other",
];

export function getTrackerOptionsForDepartment(deptName, roles) {
  if ((!deptName || !DEPARTMENT_TRACKER_OPTIONS[deptName]) && (roles || []).includes("ADMIN")) {
    return DEPARTMENT_TRACKER_OPTIONS["Management"];
  }
  if (!deptName || !DEPARTMENT_TRACKER_OPTIONS[deptName]) {
    return {
      linkedWork: ["Creative Asset", "School / Client"],
      directWork: DEFAULT_DIRECT_TASKS,
    };
  }
  return DEPARTMENT_TRACKER_OPTIONS[deptName];
}
